import { inject } from '@angular/core';
import { PartialMatchRouteSnapshot, RedirectFunction, Router, UrlTree } from '@angular/router';
import { buildLegacySettingsRedirect } from '../../../utils/location-settings.util';

/**
 * `redirectTo` for the retired `/admin/settings` page (CWS-1921): sends
 * `?company=&location=&tab=` to the company's Location tab so old links keep working.
 */
export const legacyLocationSettingsRedirect: RedirectFunction = (
  route: PartialMatchRouteSnapshot
): UrlTree => {
  const target = buildLegacySettingsRedirect(route.queryParams);
  return inject(Router).createUrlTree(target.commands, { queryParams: target.queryParams });
};
